import React from 'react';
import BlogCard from './BlogCard';
import { useTranslation } from 'react-i18next';

const BlogSecOne = ({ className }) => {
  const { t } = useTranslation();

  return (
    <section className={className}>
      <div 
        className="shape-mockup bg-gradient-shape1 blog-bg-gradient1" 
        data-top="10%" 
        data-right="0" 
        data-left="auto"
      />
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title" data-cue="slideInUp">{t('sections.blogSecOne.sub_title','New & Blog')}</span>
          <h2 className="sec-title" data-cue="slideInUp">
            {t('sections.blogSecOne.title','Powerful Cyber Security <br /> Solutions')}
          </h2>
        </div>
        <div className="row gy-4 justify-content-center">
          <BlogCard className="col-lg-4 col-md-6" limit={3} />
        </div>
      </div>
    </section>
  );
};

export default BlogSecOne;